import { axiosServer } from "../axiosServer";
import buildLink from "../urls";

export async function getDetectedOrderType(orderId) {
  const checkUrl = buildLink("checkOrderType") + `&order_id=${orderId}`;

  try {
    const response = await axiosServer.get(checkUrl);

    if (response?.data?.success && response?.data?.type) {
      return {
        success: true,
        type: response.data.type,
      };
    }

    return {
      success: false,
      message: response?.data?.message || "Failed to check order type",
    };
  } catch (error) {
    return {
      success: false,
      message:
        error?.response?.data?.message || "Failed to check order type",
    };
  }
}
